export const SECURE_MESSAGE_LEGAL_HEADER_LOADED = 'SECURE_MESSAGE_LEGAL_HEADER_LOADED';
export const CARE_PROVIDER_SELECTED = 'CARE_PROVIDER_SELECTED';
export const SECURE_MESSAGES_THREADS_LOADED = 'SECURE_MESSAGES_THREADS_LOADED';
export const SECURE_MESSAGES_TOGGLE_FILTER_PANEL = 'SECURE_MESSAGES_TOGGLE_FILTER_PANEL';
export const SECURE_MESSAGES_THREAD_LOAD_SUCCESS = 'SECURE_MESSAGES_THREAD_LOAD_SUCCESS';
export const SHOW_SECURE_MESSAGE_REPLY_ITEM = 'SHOW_SECURE_MESSAGE_REPLY_ITEM';
export const SECURE_MESSAGE_THREAD_THREAD_SELECTED = 'SECURE_MESSAGE_THREAD_THREAD_SELECTED';
export const SECURE_MESSAGE_ARCHIVE_THREAD_SELECTED = 'SECURE_MESSAGE_ARCHIVE_THREAD_SELECTED';
export const SECURE_MESSAGE_THREAD_CLEAR = 'SECURE_MESSAGE_THREAD_CLEAR';
export const SHOW_SECURE_MESSAGE_LIST_VIEW = 'SHOW_SECURE_MESSAGE_LIST_VIEW';
export const SECURE_MESSAGES_UNREAD_COUNT_LOADED = 'SECURE_MESSAGES_UNREAD_COUNT_LOADED';
